var _g, _rect, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoFooter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-footer",
    xmlns: "http://www.w3.org/2000/svg",
    width: 184.51,
    height: 27,
    viewBox: "0 0 184.51 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KhimkiBC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M4.59,14.05,2.9,15.81V19H0V6.4H2.9v5.89L8.51,6.4h3.24L6.51,12l5.53,7H8.64Z",
    fill: "#616d7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M21.92,10.25a4.278,4.278,0,0,1,1.11,3.21V19H20.22V13.89a2.508,2.508,0,0,0-.51-1.72,1.827,1.827,0,0,0-1.45-.57,2.24,2.24,0,0,0-1.7.66,2.719,2.719,0,0,0-.63,2V19h-2.8V5.64h2.8v4.68a3.917,3.917,0,0,1,1.35-.85,4.863,4.863,0,0,1,1.73-.3A4,4,0,0,1,21.92,10.25Z",
    fill: "#616d7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M25.71,7.52a1.53,1.53,0,0,1-.078-2.162q.037-.04.078-.078a1.768,1.768,0,0,1,1.26-.45,1.842,1.842,0,0,1,1.26.44,1.372,1.372,0,0,1,.48,1.08,1.551,1.551,0,0,1-.48,1.16A1.807,1.807,0,0,1,26.97,8,1.767,1.767,0,0,1,25.71,7.52Zm-.15,1.8h2.81V19H25.56Z",
    fill: "#616d7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M46.27,10.24a4.358,4.358,0,0,1,1.07,3.22V19H44.51V13.89a2.612,2.612,0,0,0-.48-1.72,1.68,1.68,0,0,0-1.36-.57,2,2,0,0,0-1.57.64,2.782,2.782,0,0,0-.57,1.9V19H37.75V13.89c0-1.53-.61-2.29-1.84-2.29a2,2,0,0,0-1.54.64,2.731,2.731,0,0,0-.58,1.9V19H30.98V9.32h2.68v1.11a3.4,3.4,0,0,1,1.33-.93,4.371,4.371,0,0,1,1.72-.33,4.142,4.142,0,0,1,1.85.41,3.228,3.228,0,0,1,1.33,1.18,3.924,3.924,0,0,1,1.5-1.17,4.708,4.708,0,0,1,2-.42A3.9,3.9,0,0,1,46.27,10.24Z",
    fill: "#616d7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M54.02,15.2l-1.35,1.33V19H49.86V5.64h2.81V13.2l4.11-3.88h3.34l-4,4.1L60.51,19h-3.4Z",
    fill: "#616d7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M61.82,7.52a1.53,1.53,0,0,1-.078-2.162q.037-.04.078-.078a1.768,1.768,0,0,1,1.26-.45,1.842,1.842,0,0,1,1.26.44,1.372,1.372,0,0,1,.48,1.08,1.551,1.551,0,0,1-.48,1.16A1.807,1.807,0,0,1,63.08,8,1.767,1.767,0,0,1,61.82,7.52Zm-.15,1.8h2.84V19H61.67Z",
    fill: "#616d7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M78.23,13.59a3.127,3.127,0,0,1,.61,2,2.93,2.93,0,0,1-1.28,2.55,6.635,6.635,0,0,1-3.76.89H67.29V6.4h6.15a6,6,0,0,1,3.54.88,2.8,2.8,0,0,1,1.23,2.4,3,3,0,0,1-.44,1.63,3.074,3.074,0,0,1-1.26,1.14A3.36,3.36,0,0,1,78.23,13.59Zm-8-5v3h2.89a2.938,2.938,0,0,0,1.64-.38,1.342,1.342,0,0,0,.308-1.874A1.356,1.356,0,0,0,74.72,9a2.992,2.992,0,0,0-1.64-.36Zm5.13,7.83a1.321,1.321,0,0,0,.59-1.17c0-1-.78-1.57-2.32-1.57h-3.4V16.8h3.4a3.222,3.222,0,0,0,1.69-.37Z",
    fill: "#616d7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M83.6,18.38a6.256,6.256,0,0,1-2.44-2.32,6.349,6.349,0,0,1-.89-3.36,6.349,6.349,0,0,1,.89-3.36A6.251,6.251,0,0,1,83.6,7a7.283,7.283,0,0,1,3.51-.84,7.443,7.443,0,0,1,3,.58A5.9,5.9,0,0,1,92.33,8.4l-1.87,1.72a4,4,0,0,0-3.17-1.47,4.232,4.232,0,0,0-2.09.51,3.642,3.642,0,0,0-1.43,1.43,4.232,4.232,0,0,0-.51,2.09,4.232,4.232,0,0,0,.51,2.09A3.642,3.642,0,0,0,85.2,16.2a4.232,4.232,0,0,0,2.09.51,4,4,0,0,0,3.17-1.49L92.29,17a5.789,5.789,0,0,1-2.23,1.67,7.5,7.5,0,0,1-3,.58A7.232,7.232,0,0,1,83.6,18.38Z",
    fill: "#616d7f"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 86,
    height: 27,
    rx: 4,
    transform: "translate(98.51)",
    fill: "#616d7f"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "events"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M119.87,17v1h-6.1V9.6h5.93v1h-4.73v2.58h4.21v1h-4.21V17Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M130.91,9.6,127.22,18h-1.19l-3.69-8.4h1.29l3,6.9,3-6.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M139.99,17v1h-6.1V9.6h5.93v1h-4.73v2.58h4.22v1h-4.22V17Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M151.08,9.6V18h-1l-5-6.26V18h-1.2V9.6h1l5,6.26V9.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M157.19,10.64h-2.88v-1h6.94v1h-2.88V18h-1.18Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M164.99,17.8a3.61,3.61,0,0,1-1.38-.8l.44-.94a3.651,3.651,0,0,0,1.23.71,4.5,4.5,0,0,0,1.54.27,2.72,2.72,0,0,0,1.56-.36,1.07,1.07,0,0,0,.52-.94,1,1,0,0,0-.28-.7,1.987,1.987,0,0,0-.7-.42c-.28-.09-.67-.2-1.17-.32a10.73,10.73,0,0,1-1.53-.46,2.49,2.49,0,0,1-1-.7,1.889,1.889,0,0,1-.41-1.28,2.216,2.216,0,0,1,.35-1.21,2.425,2.425,0,0,1,1.08-.86,4.276,4.276,0,0,1,1.79-.33,5.588,5.588,0,0,1,1.46.2,3.794,3.794,0,0,1,1.24.55l-.4,1a3.985,3.985,0,0,0-1.13-.51,4.069,4.069,0,0,0-1.17-.18,2.568,2.568,0,0,0-1.53.38,1.12,1.12,0,0,0-.51,1,.929.929,0,0,0,.28.7,2,2,0,0,0,.72.42c.28.1.67.2,1.16.32a11.673,11.673,0,0,1,1.52.45,2.646,2.646,0,0,1,1,.7,1.807,1.807,0,0,1,.41,1.26,2.12,2.12,0,0,1-.36,1.2,2.348,2.348,0,0,1-1.09.87,4.561,4.561,0,0,1-1.8.32,5.637,5.637,0,0,1-1.84-.34Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/logo-footer.57ad3d86c4ccb828179fd7bb1a0d6cf3.svg";
export { ForwardRef as ReactComponent };